import $api from "@/frontend/shared/api/axios";

export async function deleteCompanySectionNote({ companyId, noteId }: { companyId: number; noteId: number }) {
  return await $api.delete(`/companies/${companyId}/notes/${noteId}`);
}
